import api from '@/services/api'

export default (event, data) => {
    data = { ...getDefaultData(), ...data }
    window.SrAnalytics.track(event, data)
}

function getDefaultData() {
    return {
        site_access_id: api.clientData('site_access_id'),
        site: api.clientData('domain').slug,
        domain: window.location.host
    }
}